module.exports = __webpack_public_path__ + "img/bingo_ball-88.9ba0326e.png";